export { ArtistProfile } from './ArtistProfile';
